import {
  type LotField,
  type LotType,
  type ServicePlace,
  type ServiceType,
  LotFieldLabel,
  ORDERED_LOT_LIST,
  ServicePlaceLabel,
  ServiceTypeLabel,
} from 'src/constants';

const CUSTOM_LOT_LOCATION_LABEL: Partial<Record<LotType, Record<string, string>>> =
  typeof window.LOT_LOCATION_LABEL === 'object'
    ? Object.entries(window.LOT_LOCATION_LABEL)
        .filter(
          ([lotType, data]) =>
            ORDERED_LOT_LIST.some((type) => type === lotType) && typeof data === 'object'
        )
        .reduce((acc, [lotType, data]) => ({ ...acc, [lotType]: data }), {})
    : {};

export const getLotFieldLabel = (lotType: LotType, lotField: LotField) => {
  return CUSTOM_LOT_LOCATION_LABEL[lotType]?.[lotField] || LotFieldLabel[lotField];
};

export const getServicePlaceLabel = (lotType: LotType, servicePlace: ServicePlace) => {
  return CUSTOM_LOT_LOCATION_LABEL[lotType]?.[servicePlace] || ServicePlaceLabel[servicePlace];
};

export const getServiceTypeLabel = (lotType: LotType, serviceType: ServiceType) => {
  return CUSTOM_LOT_LOCATION_LABEL[lotType]?.[serviceType] || ServiceTypeLabel[serviceType];
};
